import React from 'react'

// Grommet
import { ResponsiveContext } from 'grommet'

import Grid from '../components/simple/grid/Grid.js'

const breakpointFallbacks = ['small', 'medium', 'large', 'xlarge']

const resolveResponsiveValue = (value, size) => {
  if (value === undefined || value === null) return value
  if (Array.isArray(value) || typeof value === 'string') return value

  if (typeof value === 'object') {
    if (Object.prototype.hasOwnProperty.call(value, 'count') || Object.prototype.hasOwnProperty.call(value, 'size')) {
      return value
    }

    if (Object.prototype.hasOwnProperty.call(value, size)) {
      return value[size]
    }

    if (size === 'xsmall' && Object.prototype.hasOwnProperty.call(value, 'small')) {
      return value.small
    }

    for (const fallback of breakpointFallbacks) {
      if (Object.prototype.hasOwnProperty.call(value, fallback)) {
        return value[fallback]
      }
    }

    return undefined
  }

  return value
}

const Responsive = ({
  children,
  columns,
  rows,
  overrideColumns,
  overrideRows,
  areas,
  ...props
}) => (
  <ResponsiveContext.Consumer>
    {size => {
      // columns, rows and areas are for Grid with a known number of contents / boxes.

      // If the size is small, we only see 1 column
      // If the size is either medium, large or xlarge, we see 4 columns
      // const columns = {
      //   small: ['auto'],
      //   medium: ['auto', 'auto', 'auto', 'auto'],
      //   large: ['auto', 'auto', 'auto', 'auto'],
      //   xlarge: ['auto', 'auto', 'auto', 'auto']
      // }

      // const rows = {
      //   small: 'xsmall',
      //   medium: 'xsmall',
      //   large: 'xsmall',
      //   xlarge: 'xsmall'
      // }

      // Default the rows to xsmall if no props
      if (!rows) {
        rows = 'xsmall'
      }

      const columnsVal = resolveResponsiveValue(columns, size)
      const rowsVal = resolveResponsiveValue(rows, size)

      // Also if areas is a simple array not an object of arrays for
      // different sizes
      let areasVal = areas
      if (areas && !Array.isArray(areas)) {
        areasVal = resolveResponsiveValue(areas, size)
      }

      return (
        <Grid
          {...props}
          areas={!areasVal ? undefined : areasVal}
          rows={!rowsVal ? size : rowsVal}
          columns={!columnsVal ? size : columnsVal}
        >
          {children}
        </Grid>
      )
    }}
  </ResponsiveContext.Consumer>
)

export default Responsive
